<div class=" o-modal--medium" id="termsCardReposition" style="width: 100%;">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" (click)="Close()"  matDialogClose></a>
          <label class="o-title o-title--white o-title--medium"> {{'CardRepositionTermsPortal.title' | translate}} </label> 
    </div>
    <mat-dialog-content style="width:95%; margin: 10px;">
            <div class="o-modal__text">
                <div class="o-text" *ngFor="let paragraph of bodyTranslation">{{paragraph}}</div>
            </div>
    </mat-dialog-content>
    <div class="o-modal__footer">
         <div>
             <button mat-button mat-dialog-close (click)="Close()" class="btn btn--default " style="color:black" ><u> {{'CardRepositionTermsPortal.btnCancel' | translate}}</u></button>
            <button mat-button (click)="Accept()" class="btn btn--primary" >  {{'CardRepositionTermsPortal.btnAccept' | translate}} </button>
        </div> 
    </div>
</div>
